<div class="host-base-calendar">
  <div class="calendar-header">
    <div class="column" *ngFor="let month of currentRange; let isLast = last; let isFirst = first">
      <i
        nz-icon
        nzType="left"
        nzTheme="outline"
        class="arrow left-arrow"
        *ngIf="isFirst"
        (click)="onClickArrow('prev')"
      ></i>
      <!-- <span class="arrow left-arrow" *ngIf="isFirst" (click)="onClickArrow('prev')"></span> -->
      {{ month.format("YYYY-MM") }}
      <i
        nz-icon
        nzType="right"
        nzTheme="outline"
        class="arrow right-arrow"
        *ngIf="isLast"
        (click)="onClickArrow('next')"
      ></i>
      <!-- <span class="arrow right-arrow" *ngIf="isLast" (click)="onClickArrow('next')"></span> -->
    </div>
  </div>
  <div class="calendar-body">
    <div class="column" *ngFor="let month of currentRange">
      <host-calendar class="left-calendar" [showPicker]="false" [showYear]="month.year()" [showMonth]="month.month()">
        <ng-template #header let-listOfWeekName>
          <div
            class="column-header"
            [class.weekend]="i === 0 || i === 6"
            *ngFor="let day of listOfWeekName; let i = index"
          >
            {{ day }}
          </div>
        </ng-template>
        <ng-template #cell let-day>
          <div
            class="cell-body"
            [class.selected]="isSelected(day) && !isAnotherMonth(day)"
            [class.disabled]="isDisabledDate(day)"
            [class.range]="isInRange()"
            [style.width]="cellWidth"
            [style.height]="cellHeight"
            (click)="onClickCell(day)"
          >
            <span
              class="date"
              [class.another-month]="isAnotherMonth(day)"
              [class.today]="day.isCurrentDay && !day.isSelectedDay"
            >
              {{ day.number }}
            </span>
          </div>
        </ng-template>
      </host-calendar>
    </div>
  </div>
</div>
